import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'encodeRate';

export class EncodeRate extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
